export const SOURCE_TAG_NAME = 'SOURCE';
export const WEBP = 'image/webp';
